<template>
  <div class="position-relative">
    <b-container class="sponsors">
      <b-row>
        <b-col xl="1"></b-col>
        <b-col>
          <h2
            class="pt-5 mt-5 mt-md-0 pb-3 text-light text-center"
            style="font-size: 2rem"
          >
            Our splendid partners
          </h2>
        </b-col>
      </b-row>

      <!-- Splendid Partners -->
      <b-row
        no-gutters
        :class="splendidPartners.length < 4 ? 'justify-content-center' : ''"
      >
        <Sponsor
          v-for="partner in splendidPartners"
          :key="partner.index"
          :url="partner.url"
          :image="partner.image"
        />
      </b-row>
      <b-row no-gutters> </b-row>

      <b-row class="mt-5">
        <b-col xl="1"></b-col>

        <b-col>
          <h2 class="pt-5 pb-3 text-light text-center" style="font-size: 2rem">
            Media & press partners
          </h2>
        </b-col>
      </b-row>
      <!-- Media & press partners -->
      <b-row
        no-gutters
        :class="mediaPartners.length < 4 ? 'justify-content-center' : ''"
      >
        <Sponsor
          v-for="mediaPartner in mediaPartners"
          :key="mediaPartner.index"
          :url="mediaPartner.url"
          :image="mediaPartner.image"
        />
      </b-row>

      <b-row class="mt-5" v-if="bestCompanies.length">
        <b-col xl="1"></b-col>

        <b-col>
          <h2 class="pt-5 pb-3 text-light text-center" style="font-size: 2rem">
            Best companies
          </h2>
        </b-col>
      </b-row>
      <!-- Best companies -->
      <b-row
        no-gutters
        v-if="bestCompanies.length"
        :class="bestCompanies.length < 4 ? 'justify-content-center' : ''"
      >
        <Sponsor
          v-for="bestCompany in bestCompanies"
          :key="bestCompany.index"
          :url="bestCompany.url"
          :image="bestCompany.image"
        />
      </b-row>

      <b-row class="mt-5" v-if="collaborations.length">
        <b-col xl="1"></b-col>

        <b-col>
          <h2 class="pt-5 pb-3 text-light text-center" style="font-size: 2rem">
            Organisations we support and collaborate with
          </h2>
        </b-col>
      </b-row>
      <!-- Collabs -->
      <b-row
        no-gutters
        v-if="collaborations.length"
        :class="collaborations.length < 4 ? 'justify-content-center' : ''"
      >
        <Sponsor
          v-for="collab in collaborations"
          :key="collab.index"
          :url="collab.url"
          :image="collab.image"
        />
      </b-row>

      <b-col xl="1"></b-col>
    </b-container>
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1712048062/2024/green-pink-circles.png"
      alt="triangle"
      class="position-absolute d-none d-xl-block"
      style="width: 140px; top: 65%; left: 0%"
    />
  </div>
</template>


<script>
import Sponsor from "./Sponsor.vue";

export default {
  components: { Sponsor },

  data() {
    return {
      splendidPartners: [
        {
          url: "https://se.devoteam.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1713776742/2024/Logos/Devoteam_logo.png",
        },

        {
          url: "https://www.55degrees.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1712929259/2024/Logos/55degrees-web.png",
        },
        {
          url: "https://modelon.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1688453702/2023_web/Modelon_logo_web.png",
        },
        {
          url: "https://www.skatteverket.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1712929274/2024/Logos/Skatteverket-web.png",
        },
        {
          url: "https://ravendb.net/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1696514486/2023_web/logos/ravendb_logo_web.png",
        },

        {
          url: "https://www.couchbase.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1681644853/2023_web/logos/Couchbase_TopoftheRock.png",
        },
        {
          url: "https://codescene.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715351436/2024/Logos/Codescene-web.png",
        },
        {
          url: "https://www.sweco.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715683958/2024/Logos/Sweco-web.png",
        },
        {
          url: "https://www.fortnox.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715855980/2024/Logos/Fortnox-web.png",
        },
        {
          url: "https://engineeringat.axis.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718193463/2024/Logos/2.Axis-logo.png",
        },
        {
          url: "https://www.truesec.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718364371/2024/Logos/Truesec-web.png",
        },
        {
          url: "https://www.sbab.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1719921826/2024/Logos/2.-SBAB-logo-web.png",
        },
        {
          url: "https://www.sinch.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1721044411/Sinch-web.png",
        },
      ],
      mediaPartners: [
        {
          url: "https://kodsnack.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1681295064/2023_web/logos/Kodsnack_mediapartners.png",
        },
        {
          url: "https://developerspodcast.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1683114377/2023_web/logos/developers_pressmedia.png",
        },
        {
          url: "https://kube.events/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1713771905/2024/Logos/2.Kube-events-web.png",
        },
        {
          url: "https://learnk8s.io/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1713771905/2024/Logos/Learn-k8s-web.png",
        },
        {
          url: "https://www.manning.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715946275/2024/Logos/Manning-web.png",
        },
        {
          url: "https://underjord.io/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1716984233/2024/Logos/2.underjord_web.png",
        },
        {
          url: "https://www.aktuellsakerhet.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1727358401/AktuellSakerhet-web.png",
        },
      ],
      bestCompanies: [
        {
          url: "https://www.handelsbanken.se/sv/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1696876148/2023_web/logos/Handelsbanken_logo_web.png",
        },
        {
          url: "https://ecrucial.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726080259/Ecrucial_Website.png",
        },
        {
          url: "https://www.qlik.com/us",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726080286/Qlik_Website.png",
        },
        {
          url: "https://www.migrationsverket.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726081864/Migrationsverket_Logo.png",
        },
        {
          url: "https://www.forsvarsmakten.se/sv/organisation/forsvarsmaktens-telekommunikations-och-informationssystemforband-fmtis/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726810079/ForsvarsmaktenLogo.png",
        },
        {
          url: "https://keylane.com",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726809881/KeylaneLogo.png",
        },
        {
          url: "https://minuba.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1727358705/Minuba-web.png",
        },
        {
          url: "https://www.hogia.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1727873110/Hogia-web.png",
        },

      ],
      collaborations: [
        {
          url: "https://www.foocoding.org/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1696317955/2023_web/logos/foocoding_logo_web.png",
        },
        {
          url: "https://www.redi-school.org/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1697041067/2023_web/logos/ReDi_School_logo_web.png",
        },
        {
          url: "https://pinkprogramming.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715176023/2024/Logos/pink_programming_logo_web.png",
        },
        {
          url: "https://event.toa.media/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1713344941/2024/Logos/TOA-web.png",
        },
        {
          url: "https://www.mediaevolution.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1719921826/2024/Logos/2.MEC-logo-web.png",
        },
                {
          url: "https://womenintechalliance.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726080300/WomenInTech_Website.png",
        },
        {
          url: "https://foocafe.org/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726080272/FooCafe_Website.png",
        },
        {
          url: "https://www.theground.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1726810196/GroundLogo.png",
        },
        {
          url: "https://www.corechange.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1727873124/2.CoreChange-web.png",
        },
        {
          url: "https://malmo.se",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1728302061/MalmoStad-web.png",
        },
        {
          url: "https://stpln.org/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1728917577/STPLN-web.png",
        },
        {
          url: "https://www.fridastjernholm.com/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1729085831/FridaS-web.png",
        },
        {
          url: "https://backyard-sessions.se/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1715351695/2024/Logos/Backyard-web.png",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/Sponsors.vue